import { render } from "./SupplierList.vue?vue&type=template&id=e0f182b4"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__